var exports = {
  "az": "Box__0K17vj",
  "wy": "Box_1__wW_V7a",
  "pv": "Box_2__2RzMbJ",
  "w9": "Box_3__JB-qy4",
  "pQ": "Box_4__w6BuLE",
};

module.exports = exports;
